import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { PenEventName } from "../../common/enums/PenEnums";
import PenManager from "../../neosmartpen/PenManager";
// export const logActivePen = (pens: INeoSmartpen[], heeader = undefined as string) => {
//   console.log(`${heeader ? heeader : ""} ========= `)
//   pens?.map((pen, idx) => console.log(`active pens (${idx}) = ${pen.inputType.type}-${pen.getMac()}`))
// }
export function PenSelector(props) {
    // const [, forceUpdate] = useReducer(x => x + 1, 0);
    // const { surfaceOwnerIds } = props;
    const [allPens, setAllPens] = useState([]);
    const [activePens, setActivePens] = useState([]);
    // const handleWriterChanged = (pen: INeoSmartpen, writerId: string) => {
    //   pen.setWriterId(writerId);
    //   forceUpdate();
    // };
    //#region pen manager로부터 모든 펜의 리스트를 받아 관리하는 부분
    useEffect(() => {
        const pm = PenManager.getInstance();
        pm.addEventListener(PenEventName.ON_CONNECTED, onPenLinkChanged);
        pm.addEventListener(PenEventName.ON_DISCONNECTED, onPenLinkChanged);
        pm.addEventListener(PenEventName.ON_WRITER_CHANGED, onPenLinkChanged);
        return () => {
            const pm = PenManager.getInstance();
            pm.removeEventListener(PenEventName.ON_CONNECTED, onPenLinkChanged);
            pm.removeEventListener(PenEventName.ON_DISCONNECTED, onPenLinkChanged);
            pm.removeEventListener(PenEventName.ON_WRITER_CHANGED, onPenLinkChanged);
        };
    }, []);
    const onPenLinkChanged = (e) => {
        const pm = PenManager.getInstance();
        const newAllPens = pm.getPens();
        const added = newAllPens.filter(pen => !allPens.includes(pen));
        const removed = allPens.filter(pen => !newAllPens.includes(pen));
        const newActivePens = activePens.filter(pen => removed.includes(pen));
        newActivePens.push(...added);
        setAllPens(newAllPens);
        setActivePens(newActivePens);
    };
    //#endregion
    const handleTogglePen = (e, pen) => {
        const newActivePens = [...activePens];
        const active = newActivePens.includes(pen);
        if (active) {
            const idx = newActivePens.findIndex(item => item === pen);
            if (idx > -1) {
                newActivePens.splice(idx, 1);
            }
        }
        else {
            newActivePens.push(pen);
        }
        setActivePens(newActivePens);
        props.onReportActivePens(newActivePens);
    };
    return (_jsx(React.Fragment, { children: allPens.map((pen, index) => {
            return (_jsx("div", { children: _jsxs("label", Object.assign({ style: { margin: 0 } }, { children: [_jsx("input", { name: `check-${index}`, type: "checkbox", checked: activePens.includes(pen), onChange: (e) => handleTogglePen(e, pen) }), `${pen.inputType.type}-${pen.mac}(${pen.writerId})`] })) }, index));
        }) }));
}
//# sourceMappingURL=PenSelector.js.map